import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  resultData: {},
};

const quizResultSlice = createSlice({
  name: "quizResult",
  initialState,
  reducers: {
    setResultData: (state, action) => {
      const { moduleId, resultData } = action.payload;
      state.resultData[moduleId] = resultData;
    },
  },
});

export const { setResultData } = quizResultSlice.actions;

export default quizResultSlice.reducer;
